import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import RecipeDto from "../components/Common/dtos/RecipeDto";

export type RecipeUpsertDto = Omit<RecipeDto, 'id' | 'sites'> & { siteIds?: string[] };

const path = (businessId: string) => `/api/businesses/${businessId}/recipes`;

const createSpec = (businessId: string): UserRequestSpec => ({
  path: path(businessId),
  method: HttpMethod.POST,
});

const updateSpec = (businessId: string, recipeId: string): UserRequestSpec => ({
  path: `${path(businessId)}/${recipeId}`,
  method: HttpMethod.PUT,
});

const useUpsertRecipe = (recipeId?: string, options?: RequestOptions<string>) => {
  const business = useSelectedBusiness();

  var spec = recipeId
    ? updateSpec(business.id, recipeId)
    : createSpec(business.id);

  return useUserRequest<RecipeUpsertDto, string>(spec, options);
}

export default useUpsertRecipe;
